@if (storedParams.length) {
    <mat-expansion-panel
        [expanded]="state"
        class="is-bordered-desktop is-rounded"
        hideToggle="true"
        (opened)="state = true"
        (closed)="state = false"
    >
        <mat-expansion-panel-header>
            <mat-panel-description class="material-collapsable-button is-font-sm">
                @if (!state) {
                    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                } @if (state) {
                    <fa-icon [icon]="['fas', 'minus']"></fa-icon>
                }
            </mat-panel-description>
            @if (configuration.colapsableTitle || configuration.collapsableSubtitle)
            {
                <mat-panel-title>
                    <p class="collapsable-header mt-0 is-font-sm">
                        @if (configuration.colapsableTitle) {
                            <strong>
                                {{ configuration.colapsableTitle }}
                            </strong>
                        } @if (configuration.collapsableSubtitle) {
                            <span>
                                {{ configuration.collapsableSubtitle }}
                            </span>
                        }
                    </p>
                </mat-panel-title>
            }
        </mat-expansion-panel-header>
        <div class="filter-saved-list-container pl-2" role="listbox">
            @for (param of storedParams; track param) {
                <a
                    (click)="onApplyFilter(param)"
                    role="option"
                    tabindex="0"
                    [attr.aria-label]="'Apply filters saved ' + param"
                >
                    - {{ param }}
                </a>
            }
        </div>
    </mat-expansion-panel>
}
